module.exports = __webpack_public_path__ + "static/img/9.b0849ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/7/zh/9.png
// module id = OyTu
// module chunks = 0